import {useEffect, useState} from "react";
import {MapPin, UserPlus, UserCheck, MessageCircle, HelpCircle, Link2} from "lucide-react";
import {FormModal} from "@/components/UI";
import {apiGet, apiPost, apiDelete} from "@/lib/api";

export default function MemberModal({memberId, close, notify, requireAuth, user}) {
  const [m, setM] = useState(null);
  const [following, setFollowing] = useState(false);
  useEffect(() => {
    apiGet(`/members/${memberId}`).then(setM).catch(() => setM({error: true}));
    apiGet(`/members/${memberId}/following`).then(r => setFollowing(r.following)).catch(() => {});
  }, [memberId]);
  const follow = () => requireAuth(async () => {
    try {
      if (following) { await apiDelete(`/members/${memberId}/follow`); setFollowing(false); setM(x => ({...x, followers: Math.max(0, (x.followers || 1) - 1)})); notify(`Unfollowed ${m.name}`); }
      else { await apiPost(`/members/${memberId}/follow`, {}); setFollowing(true); setM(x => ({...x, followers: (x.followers || 0) + 1})); notify(`You're following ${m.name} — you'll be notified of their posts`); }
    } catch { notify("You can't follow this profile"); }
  });
  if (!m) return null;
  if (m.error) return <FormModal title="Profile unavailable" eyebrow="MEMBER" close={close} testId="member-modal"><p className="modal-sub">This member is no longer on Indian Ocean.</p></FormModal>;
  return (
    <FormModal title={m.name} eyebrow={m.headline || "MEMBER"} close={close} width={620} testId="member-modal">
      <div className="member-meta">
        {m.city && <span data-testid="member-city"><MapPin size={13}/> {m.city}</span>}
        <span>{m.followers || 0} followers</span>
        {user?.user_id !== memberId && <button data-testid="member-follow" className={following ? "outline-button sm" : "coral-button sm"} onClick={follow}>{following ? <><UserCheck size={13}/> Following</> : <><UserPlus size={13}/> Follow</>}</button>}
      </div>
      {m.bio && <><div className="eyebrow">ABOUT</div><p className="modal-sub" data-testid="member-bio">{m.bio}</p></>}
      {m.links?.length > 0 && <div className="profile-links">{m.links.map(l => <a key={l} href={l} target="_blank" rel="noreferrer"><Link2 size={12}/> {l.replace(/^https?:\/\//, "")}</a>)}</div>}
      <div className="eyebrow">RECENT ACTIVITY ({m.activity.length})</div>
      <div className="member-activity" data-testid="member-activity">
        {m.activity.length === 0 && <p className="admin-help">No public activity yet.</p>}
        {m.activity.slice(0, 12).map((a, i) => (
          <div key={i} className="activity-item">
            <span className="activity-badge">{a.type === "question" ? <HelpCircle size={13}/> : <MessageCircle size={13}/>} {a.type === "message" ? "post" : a.type}</span>
            <h4>{a.title}</h4>
            <small>{a.context} · {new Date(a.when).toLocaleDateString()}</small>
          </div>
        ))}
      </div>
    </FormModal>
  );
}
